import { Dialog,DialogActions,DialogContent,DialogTitle } from "@mui/material"
import { StudentSection } from "containers/AccountPage/AccountPage"
import { Student } from "data/data"
import React,{ SetStateAction,useEffect,useState } from "react"
import ButtonPrimary from "shared/Button/ButtonPrimary"
import ButtonSecondary from "shared/Button/ButtonSecondary"
import ButtonClose from "shared/ButtonClose/ButtonClose"

const DialogEditStudent = ({
  open,
  hide,
  students,
  setStudents,
  studentIndex,
  setStudentIndex
}: {
  open: boolean
  hide: () => void
  students: Student[]
  setStudents: React.Dispatch<SetStateAction<Student[]>>
  studentIndex: number | undefined
  setStudentIndex: React.Dispatch<React.SetStateAction<number|undefined>>
}) => {
  const [student, setStudent] = useState<Student | undefined>(undefined)

  useEffect(() => {
    if (open && (studentIndex !== undefined) && students[studentIndex]) {
      console.log("sdads")
      setStudent({ ...students[studentIndex] })
    }else if(!open){
      setStudentIndex(undefined)
      setStudent(undefined)
    }
  }, [open, studentIndex, students])

  const handleSave = () => {
    if(studentIndex === undefined){
      return
    }
    if (student.name) {
      setStudents((prev) => {
        const updated = [...prev]
        updated[studentIndex] = { ...student }
        return updated
      })
      setStudent({ id: students[studentIndex]?.id })
      hide()
    }
  }

  return (
    <Dialog open={open} onClose={hide}>
      <div className="flex justify-between items-center">
        <DialogTitle>
          Editar estudiante
        </DialogTitle>
        <ButtonClose onClick={hide} className="mr-4"></ButtonClose>
      </div>
      <DialogContent>
        {student && <StudentSection key={studentIndex || "none"} planeFormat item={student} setItem={setStudent} className="px-4"/>}
      </DialogContent>
      <DialogActions>
        <ButtonSecondary onClick={hide} type="button" className="w-full">Cancelar</ButtonSecondary>
        <ButtonPrimary 
          onClick={handleSave} 
          type="button" 
          disabled={!student?.name} 
          className="w-full"
        >
          Guardar
        </ButtonPrimary>
      </DialogActions>
    </Dialog>
  )
}

export default DialogEditStudent
